import React, { useContext, useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

import AuthContext, { AuthProvider } from './context/AuthContext';
import { ProfileProvider } from './context/ProfileContext';
import theme from './styles/Theme';

// Components
import Layout from './components/Layout';
import Signup from './components/SignUp';
import AuthPage from './components/AuthPage';
import GymList from './components/ListGyms';
import NotFound from './components/NotFound';
import Comments from "./components/Comments";
import UserProfile from './components/Profile';
import PrivateRoute from './utils/PrivateRoute';
import Home from './components/Home';
import LoadingScreen from './components/LoadingScreen';
import VerifyEmail from './components/VerifyEmail';
import MembershipPlans from './components/MembershipPlans';
import ResetPassword from './components/ResetPassword';

const AppContent = () => {
    const { authTokens, loading } = useContext(AuthContext);
    const [isReady, setIsReady] = useState(false);
    const location = useLocation();

    useEffect(() => {
        if (!loading) {
            const timer = setTimeout(() => {
                setIsReady(true);
            }, 2000);
            return () => clearTimeout(timer);
        }
    }, [loading]);

    // âš¡ force redirect if just logged in and path is wrong    
    if (authTokens && (location.pathname === '/auth' || location.pathname === '/signup')) {
        return <Navigate to="/home" replace />;
    }

    if (loading || !isReady) {
        return <LoadingScreen />;
    }

    return (
        <Routes>
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            {!authTokens ? (
                <>
                   {/* Route publique */}
                    <Route path="/auth" element={<AuthPage />} />
                    <Route path="/signup" element={<Signup />} />
                    <Route path="*" element={<Navigate to="/auth" replace />} />
                </>
            ) : (
                <>
                    <Route element={<Layout />}>
                        <Route path="/home" element={<PrivateRoute><Home /></PrivateRoute>} />
                        <Route path="/gyms" element={<PrivateRoute><GymList /></PrivateRoute>} />
                        <Route path="/profile" element={<PrivateRoute><UserProfile /></PrivateRoute>} />
                        <Route path="/comments" element={<PrivateRoute><Comments /></PrivateRoute>} />
                        <Route path="/memberships" element={<PrivateRoute><MembershipPlans /></PrivateRoute>} />
                        <Route path="*" element={<NotFound />} />
                    </Route>
                    <Route path="/" element={<Navigate to="/home" replace />} />
                </>
            )}
        </Routes>
    );
};

const App = () => (
    <ThemeProvider theme={theme}>
        <CssBaseline />
        <Router>
            <AuthProvider>
                <ProfileProvider>
                    <AppContent />
                </ProfileProvider>
            </AuthProvider>
        </Router>
    </ThemeProvider>
);

export default App;
